import { render, staticRenderFns } from "./IpRestrictionList.vue?vue&type=template&id=3b913fc6"
import script from "./IpRestrictionList.vue?vue&type=script&lang=js"
export * from "./IpRestrictionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports